import React from 'react'
import Table from '../../../common/table/Table.component';
import useInternalFormContext from '../../hooks/useInternalFormContext';
import { format } from 'date-fns';

function HistoryChanges() {
  const { data } = useInternalFormContext();
  const columns = [
    {
      Header: "Датум и време измене",
      accessor: "changedAt",
      Cell: ({ row }) => {
        let date = new Date(row.original.changedAt);
        return (
          <div>{format(date, "dd.MM.yyyy. HH:mm:ss")}</div>
        )
        
      },
    },
    {
      Header: "Корисник",
      accessor: "username",
    },
     {
       Header: "Уредничка напомена",
       accessor: "editorMark",
     },
  ]
  return (
    <div>
      <Table 
      columns={columns}
      data={data.internalActChangesHistory?.actsChangesHistory}
      rememberFilter={false}
      serverSide={false} />
    </div>
  )
}

export default HistoryChanges;
